var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-range-stat',_vm._b({},'date-range-stat',_vm.attrs,false),[_c('i18n',{staticClass:"has-text-grey",attrs:{"slot":"dates","path":"_.all_time"},slot:"dates"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }